/**
 * Whether a `nodes` realtime event must re-fetch that node's `node_metadata` row.
 *
 * ⚠ `node_metadata` is not live (app#132), and it holds the location the graph groups a node
 * under. Without this, a node that registers during the session has no metadata row in the store
 * and sits under "Unknown" until a reload.
 *
 * ⚠⚠ THE INSERT ALONE IS NOT ENOUGH. The router inserts the `nodes` row first and writes
 * `node_metadata` in a second statement, so a fetch on the INSERT can arrive before the row.
 * The router stamps `online_at` after both writes (`bridge.SetOnline`), so a changed `online_at`
 * is the dependable trigger. It also covers a node that reconnects from a new address, and a node
 * that was not held (offline, filtered out) and now comes online.
 */
export function needsMetadataRefresh(
  eventType: 'INSERT' | 'UPDATE' | 'DELETE',
  held: { onlineAt?: string | null } | undefined,
  incoming: { onlineAt?: string | null; deletedAt?: string | null }
): boolean {
  if (eventType === 'DELETE' || incoming.deletedAt) return false
  if (eventType === 'INSERT') return true
  if (!incoming.onlineAt) return false
  return !held || held.onlineAt !== incoming.onlineAt
}
